import { useMemo } from 'react';

import { useGetOptionsForCLA } from 'hooks/useGetOptionsForCLA';
import { useTranslation } from 'react-i18next';

import { booleanValueGetter, dateFormatter } from 'utils/grid';

import { GridColDef } from '@mui/x-data-grid-pro';

import { DutyCodePeriods } from 'components/shared/DataGrid/components/CustomCellRenderer/DutyCodePeriods';
import ColorCell from 'components/shared/Table/TableCell/DataGrid/ColorCell';
import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';

export const useGetColumnDefs = (): GridColDef[] => {
  const { t } = useTranslation('common');

  const options = useGetOptionsForCLA();

  return useMemo(
    () => [
      {
        field: 'dutyCode',
        headerName: t('dutyCode'),
        hideable: false,
        width: 90
      },
      {
        field: 'colorCode',
        headerName: t('color'),
        renderCell: ({ value }) => <ColorCell value={value} />,
        width: 50
      },
      {
        field: 'periods',
        headerName: t('periods'),
        minWidth: 300,
        renderCell: ({ value }) => {
          return <DutyCodePeriods periods={value} periodId="dutyPeriodId" />;
        },
        flex: 1
      },
      {
        field: 'description',
        headerName: t('description'),
        type: 'string',
        flex: 1
      },
      {
        field: 'validFrom',
        headerName: t('validFrom'),
        type: 'date',
        valueFormatter: dateFormatter,
        minWidth: 100
      },
      {
        field: 'validTo',
        headerName: t('validTo'),
        type: 'date',
        valueFormatter: dateFormatter,
        minWidth: 100
      },
      {
        field: 'REQUEST_EXCLUDE',
        headerName: t('dutyCodes.flags.REQUEST_EXCLUDE'),
        type: 'boolean',
        valueGetter: booleanValueGetter,
        renderCell: ({ value }) => <BooleanCell value={value} />,
        minWidth: 80
      },
      {
        field: 'ROUTE',
        headerName: t('dutyCodes.flags.ROUTE'),
        type: 'boolean',
        valueGetter: booleanValueGetter,
        renderCell: ({ value }) => <BooleanCell value={value} />,
        minWidth: 80
      }
    ],
    [t, options]
  );
};
